export default {
  SHORTCUTS_PLACEHOLDER: 'Nav_ShortcutsWidget_Placeholder',
  SHORTCUTS_PERSONALIZATION_BUTTON: 'Nav_PersonalizationButton',
  SHORTCUTS_PERSONALIZATION_MODAL_CHECKBOX: 'Nav_PersonalizationModal_Checkbox',
};
